module.exports = __webpack_public_path__ + "img/8.2e7e0fda.png";